import React from 'react'
import BackgroundVisualsSwitch from '../BackgroundVisuals/BackgroundVisualsSwitch'
import ReactScrollLink from '../General/ReactScollLink'
import useCinemaColorsAndIcons from '../hooks/useCinemaColorsAndIcons';
import getCinemaStyles from '../functions/getCinemaStyles';

const SliderBasicItemWrapper = ({
    isCurrentSlide,
    isConnectedFast,
    isInViewport,
    oddSlide, 
    kenBurnsToggle,
    isJustOneItem,
    canParallax,
    className, 
    onClick,
    pk,
    hasScrollLink,
    poster, 
    backgroundVisualsSettings, 
    autoplaySpeed, 
    backgroundImage,
    isMobile,
    trailerURL, 
    children, 
    fsk,
    cinemas
}) => {

    let cssClassIfPoster = '';
    if (backgroundVisualsSettings.style) {
        if (backgroundVisualsSettings.style.includes('PosterCenter')) cssClassIfPoster = ' slider-basic-item-content-poster-center';
        if (backgroundVisualsSettings.style.includes('PosterRight'))  cssClassIfPoster = ' slider-basic-item-content-poster-right';
    }

    const cinemaColorSettings = useCinemaColorsAndIcons()
    const {cinemaColor} = getCinemaStyles(cinemaColorSettings, cinemas)
    const oddSlider = className.search('odd') !== -1 

    const style = cinemaColor && oddSlider ? {
        background: cinemaColor
    } : {}

    return (
        hasScrollLink ? (
            <ReactScrollLink to={className + ' movieInformation'} className={pk + ' slick-slide-inner'} smooth={true} offset={-200} onClick={onClick}>  
                <div className={"image-wrapper cursor-pointer " + className} style={style}>
                    <BackgroundVisualsSwitch 
                        trailerURL={trailerURL}
                        fsk={fsk}
                        isCurrentSlide={isCurrentSlide}
                        isInViewport={isInViewport}
                        isConnectedFast={isConnectedFast}
                        isInHighlight={false}
                        canParallax={canParallax}
                        oddSlide={oddSlide}
                        kenBurnsToggle={kenBurnsToggle}
                        isJustOneItem={isJustOneItem}
                        backgroundVisualsSettings={backgroundVisualsSettings}
                        autoplaySpeed={autoplaySpeed}
                        isMobile={isMobile}
                        backgroundImage={backgroundImage}
                        poster={poster}
                    />

                    <div className='gradient'>
                        <div
                            className={"slider-basic-item-content"  + cssClassIfPoster}
                        >
                        {children}
                        </div>
                    </div>
                </div>
            </ReactScrollLink>
        ) : (
            <div className={"image-wrapper " + className}>
                <BackgroundVisualsSwitch 
                    trailerURL={trailerURL}
                    fsk={fsk}
                    isCurrentSlide={isCurrentSlide}
                    isInViewport={isInViewport}
                    isConnectedFast={isConnectedFast}
                    isInHighlight={false}
                    canParallax={canParallax}
                    oddSlide={oddSlide}
                    kenBurnsToggle={kenBurnsToggle}
                    isJustOneItem={isJustOneItem}
                    backgroundVisualsSettings={backgroundVisualsSettings}
                    autoplaySpeed={autoplaySpeed}
                    isMobile={isMobile}
                    backgroundImage={backgroundImage}
                    poster={poster}
                />

                <div className='gradient'>
                    <div
                        className={"slider-basic-item-content"  + cssClassIfPoster}
                    >
                    {children}
                    </div>
                </div>
            </div>
        )
    )
}

export default SliderBasicItemWrapper